import { render, staticRenderFns } from "./export.vue?vue&type=template&id=060dc604&"
import script from "./export.vue?vue&type=script&lang=js&"
export * from "./export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports